<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
// @ is an alias to /src
// import Nav from "@/components/Nav.vue";

export default {
  // components: {
  //   Nav
  // }
};
</script>

<style lang="scss">
ul,
p,
body {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #000;
}
#app {
  .Nav-hader {
    padding: 0;
  }
}
</style>
